import React from 'react';
import PropTypes from 'prop-types';
import ExpandableList from '@hydra/common/components/ExpandableList';
import { Label } from '@hydra/common/components';
import DCUrl from '@hydra/routes/crawler/utils/DCUrl';
import { Link } from '@material-ui/core';

function ItemWrapper ({ item, children, style }) {
  return (
    (item instanceof DCUrl && item.fullPath)
      ? (
        <Link href={item.fullPath} target='_blank' rel='nofollow noopener noreferrer' title={item.visibleUrl}>
          <Label noBackground truncate>{children}</Label>
        </Link>
        )
      : <Label title={item} noBackground truncate>{children}</Label>
  );
}

function List ({
  items,
  itemsVisible,
  visible,
  bullet,
  style
}) {
  const itemList = Array.isArray(items) ? items : [items];
  const bulletItem = (bullet !== '') ? bullet : null;

  return (
    <ExpandableList itemsVisible={itemsVisible || visible}>
      {
        (itemList.length > 1)
          ? itemList.map((item, index) => (
            <ItemWrapper key={index + item} item={item} style={style}>
              {bulletItem}
              {item instanceof DCUrl ? item.visibleUrl : item}
            </ItemWrapper>
            ))
          : (
            <ItemWrapper item={itemList[0]} style={style}>
              {bulletItem}
              {itemList[0] instanceof DCUrl ? itemList[0].visibleUrl : itemList[0]}
            </ItemWrapper>
            )
      }
    </ExpandableList>
  );
}

List.propTypes = {
  style: PropTypes.oneOf([
    'default',
    'primary',
    'success',
    'warning',
    'error'
  ]),
  bullet: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.object,
    PropTypes.node
  ]),
  visible: PropTypes.number,
  items: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(DCUrl)
      ])
    ),
    PropTypes.string,
    PropTypes.instanceOf(DCUrl)
  ]).isRequired
};

List.defaultProps = {
  style: 'default',
  bullet: '',
  visible: 5
};

export default List;
